import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { smoothScrollToElement } from "@/lib/smoothScroll";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  // Force consistent scroll-on-reload behavior across browsers
  useEffect(() => {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          smoothScrollToElement(el, 800, "center");
        }
      }, 100);
    } else {
      // Immediate scroll for route changes
      window.scrollTo(0, 0);
      // Fallback for cases where content hasn't rendered yet
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
